import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';


@Injectable({
    providedIn: 'root'
})
export class ControlPerfil {

    private perfiles = new Subject<any>();
    showCreatePerfil: boolean = false;
    loadingCreatePerfil: boolean = false;
    savedCreatePerfil: boolean = false;
    agregarPerfilNombre = null;

    constructor(
        private ctrlVehiculo: ControlVehiculosService,
    ) {
    }

    /**
     * Ordena alfabeticamente listado de Perfiles
     * @param a 
     * @param b 
     * @example moviles.sort(orderMoviles)
     */
    orderPerfiles(a, b) {
        const bandA = (a.nombre) ? a.nombre.toUpperCase() : a.nombre.toUpperCase();
        const bandB = (b.nombre) ? b.nombre.toUpperCase() : b.nombre.toUpperCase();
        let comparison = 0;
        if (bandA > bandB) {
            comparison = 1;
        } else if (bandA < bandB) {
            comparison = -1;
        }
        return comparison;
    }

    getListaPerfiles() {
        return this.perfiles.asObservable();
    }
    
    setListaPerfiles(obj) {
        return this.perfiles.next(obj);
    }

    listaPerfiles() {
        this.ctrlVehiculo.getListaPerfiles().subscribe(res => {
            res['rows'].sort(this.orderPerfiles);
            this.setListaPerfiles(res['rows']);
        });
    }

    getPerfil(idperfil) {
        return this.ctrlVehiculo.getPerfil(idperfil);
    }

    createPerfil(agregarPerfilNombre) {
        this.loadingCreatePerfil = true;
        return this.ctrlVehiculo.savePerfil(agregarPerfilNombre);            
    }
    
    updatePerfil(agregarPerfilNombre) {
        this.loadingCreatePerfil = true;
        return this.ctrlVehiculo.updatePerfil(agregarPerfilNombre);            
    }

    delPerfil(perfil_id) {
        return this.ctrlVehiculo.removePerfil(perfil_id);
    }

}